query getDepositAddress {
	getDepositAddress
}
